import { useQuery } from "react-query";
import http from "infra/http";

function useGrupoImpressaoContaIds(hash?: string) {
  return useQuery(
    ["grupo-impressao-conta-ids", hash],
    async () => {
      const { data } = await http.get(`/v1/boleto/multiplo/grupo/${hash}/ids`);

      return data as {
        contaIds: string[];
        contas: { contaId: string; unidade: { nome: string } | null }[];
      };
    },
    {
      enabled: !!hash,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
}

export default useGrupoImpressaoContaIds;
